import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaExtratoResumoCondutorRequest } from './types';

// ACTIONS
import {
	consultaExtratoResumoCondutorSuccess,
	consultaExtratoResumoCondutorFailure,
} from './actions';

function* consultaExtratoResumoCondutor(request: ReducerAction) {
	const { payload }: { payload: ConsultaExtratoResumoCondutorRequest } =
		request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`eportal/${CHANNEL}/pesquisa/resumo`,
		payload,
	);

	if (response.status === 200 || response.status === 204) {
		yield put(
			consultaExtratoResumoCondutorSuccess({ response, request: payload }),
		);
	} else {
		yield put(consultaExtratoResumoCondutorFailure(response));
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_EXTRATO_RESUMO_CONDUTOR_REQUEST,
		consultaExtratoResumoCondutor,
	),
]);
